export default "__VITE_ASSET__CXDXp5nC__"